<link *ngIf="loadCustomStyle" rel="stylesheet" [href]="customStyleUrl">

<div kendoDialogContainer></div>

<div class="d-flex flex-column" style="min-height: 100vh;">
    <app-nav-bar></app-nav-bar>

    <div class="view-container flex-grow-1">
        <router-outlet></router-outlet>
    </div>
    
    <app-footer></app-footer>
</div>

